/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Graduationthirdtesttopic3Inputs */

const de__field_graduationthirdtesttopic3 = /** @type {(inputs: _Field_Graduationthirdtesttopic3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drittes Prüfungsthema Abschluss`)
};

/**

* @param {_Field_Graduationthirdtesttopic3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_graduationthirdtesttopic3 = /** @type {((inputs?: _Field_Graduationthirdtesttopic3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Graduationthirdtesttopic3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_graduationthirdtesttopic3(inputs)
});
export { _field_graduationthirdtesttopic3 as "_field_graduationThirdTestTopic" }